import axios from 'axios';
import { AuthService } from './auth.service';
import { ENDPOINTS } from '../constants/endpoints';

export const DeviceApiKeyService = {
    getByInstitution: async () => {
        const institutionId = AuthService.getSelectedInstitution();
        const response = await axios.get(ENDPOINTS.DEVICE_API_KEY.BY_INSTITUTION(institutionId), {
            headers: AuthService.getAuthHeader()
        });
        return response.data;
    },

    generate: async (description: string, deviceSn: string) => {
        const institutionId = AuthService.getSelectedInstitution();
        const response = await axios.post(
            ENDPOINTS.DEVICE_API_KEY.BY_INSTITUTION(institutionId),
            { description, deviceSn },
            { headers: AuthService.getAuthHeader() }
        );
        return response.data;
    },

    rotate: async (id: string) => {
        const response = await axios.post(
            ENDPOINTS.DEVICE_API_KEY.ROTATE(id),
            {},
            { headers: AuthService.getAuthHeader() }
        );
        return response.data;
    },

    toggleActive: async (id: string) => {
        const response = await axios.patch(
            ENDPOINTS.DEVICE_API_KEY.TOGGLE_ACTIVE(id),
            {},
            { headers: AuthService.getAuthHeader() }
        );
        return response.data;
    },

    deleteKey: async (id: string) => {
        await axios.delete(ENDPOINTS.DEVICE_API_KEY.DELETE(id), {
            headers: AuthService.getAuthHeader()
        });
    },
};
